<template lang="pug">
  .section-layout
    .nav-back-btn(@click="goBack")
    .content-layout-list
      h2.title-filter 助力详情
      .revenue.top-total
        div.income
          div.statistics.no-border
            div.static-item
              div.title 发起助力人数
              div.price {{statistic_data.help_launch_count}}
            div.static-item
              div.title 发起助力次数
              div.price {{statistic_data.help_launch_total}}
          div.statistics
            div.static-item
              div.title 参与助力人数
              div.price {{statistic_data.help_join_count}}
            div.static-item
              div.title 参与助力次数
              div.price {{statistic_data.help_join_total}}
          div.statistics.max-static
            div.static-item
              div.title 分享助力人数
              div.price {{statistic_data.help_share_count}}
            div.static-item
              div.title 分享助力次数
              div.price {{statistic_data.help_share_total}}
            div.static-item
              div.title 分享率
              div.price {{statistic_data.help_share_avg}}
      .revenue.top-total
        div.income
          div.statistics.no-border
            div.static-item
              div.title 用券人数
              div.price {{statistic_data.help_coupon_user_total}}
            div.static-item
              div.title 用券张数
              div.price {{statistic_data.help_coupon_use_count}}
          div.statistics.no-border
            div.static-item
              div.title 用券订单数
              div.price {{statistic_data.help_coupon_order_count}}
            div.static-item
              div.title 助力拉新数
              div.price {{statistic_data.help_new_user_count}}
      .section-filter
        .field-group.is-horizontal
          .field
            label.label 关键字
            .field.is-horizontal
              custom-input(v-model="filter_data.keyword", placeholder="请输入手机号", @keyupEnter="search", need-type="number", maxlength="11")
          .field.staff-wrapper
            label.label 助力状态
            custom-select(v-model="filter_data.status", :list="status_list", nameField="name")
          .field
            a.button.primary(@click="search") 搜索
          .field
            a.button(@click="reset") 重置
        .time
          a.button(@click="exportTable") 导出
      empty-page.list-height(v-if="!list.length", :tip="'暂无助力记录'")
      .content-wrapper.revenue(v-if="list.length")
        div.order-statistics.p-t-20.inspect-store
          div
            ul.order-income
              li 昵称
              li 手机号
              li 发起时间
              li 助力人数
              li 助力状态
              li 助力成功时间
          div(v-for="(item, index) in list")
            ul.order-income-content
              li {{item.nick_name || '--'}}
              li {{item.mobile || '--'}}
              li
                .date(v-if="item.created_at") {{item.created_at | date("yyyy-MM-dd HH:mm:ss", "cn")}}
                .date(v-else) --
              li {{item.assist_num}} / {{item.need_num}}
              li {{status_list[item.status].name}}
              li
                .date(v-if="item.success_at") {{item.success_at | date("yyyy-MM-dd HH:mm:ss", "cn")}}
                .date(v-else) --
          .tfoot(v-if="list.length")
            pagination(:pagination-data="pagination_data", @input="paging")

</template>

<script type="text/ecmascript-6">
import DatePicker from '@/components/generics/form/DatePicker'
import Pagination from '@/components/generics/Pagination'
import EmptyPage from '@/components/generics/EmptyPage'
import Api from '@/mixins/modules/Content'
import { root } from '@/plugins/Fetch'
import ExportApi from '@/mixins/modules/export'
import CustomInput from '@/components/generics/form/CustomInput'
import CustomSelect from '@/components/generics/form/CustomSelect'
export default {
  name: 'HelpStatistic',
  mixins: [Api, ExportApi],
  components: {
    DatePicker,
    Pagination,
    EmptyPage,
    CustomInput,
    CustomSelect,
  },
  data () {
    return {
      root,
      search_info: {}, // 上一页的时间筛选
      filter_data: {
        keyword: '',
        status: { id: 0, name: '全部' },
      },
      status_list: [ // 下拉选项 - 助力状态
        { id: 0, name: '全部' },
        { id: 1, name: '进行中' },
        { id: 2, name: '已失败' },
        { id: 3, name: '已成功' },
      ],
      query_data: {
        keyword: '',
        status: { id: 0, name: '全部' },
      },
      pagination_data: {
        current_page: 1,
        per_page: 20,
        last_page: 2,
        total: 0,
      },
      activity_id: 0, // 活动id
      help_id: 0, // 助力id
      statistic_data: {},
      list: [],
    }
  },
  methods: {
    // 搜索
    search () {
      for (let key in this.filter_data) {
        if (this.query_data.hasOwnProperty(key)) {
          this.query_data[key] = this.filter_data[key]
        }
      }
      this.pagination_data.current_page = 1
      this.getList()
    },
    // 重置
    reset () {
      this.filter_data = {
        keyword: '',
        status: { id: 0, name: '全部' },
      }
      this.pagination_data.current_page = 1
      this.query_data = JSON.parse(JSON.stringify(this.filter_data))
      this.getList()
    },
    // 导出
    exportTable () {
      let params = `id=${this.help_id}&mobile=${this.query_data.keyword}&status=${this.query_data.status.id || ''}&`
      let startTime = this.search_info.start_time ? new Date(this.search_info.start_time + ' 00:00:00').getTime() / 1000 : ''
      let endTime = this.search_info.end_time ? new Date(this.search_info.end_time + ' 23:59:59').getTime() / 1000 : ''
      params += `start_time=${startTime}&`
      params += `end_time=${endTime}&`
      // window.open(`${this.root}/activity/activity_order_export?${params}`)
      this.exportHelpListApi(params)
    },
    // 返回
    goBack () {
      this.$router.go(-1)
    },
    // 分页
    paging (state) {
      this.pagination_data = state
      this.getList()
    },
    // 获取数据统计
    async getStatistic () {
      try {
        const { response, result } = await this.helpStatisticDetailApi(
          {
            activity_id: this.activity_id,
            start_time: this.search_info.start_time ? new Date(this.search_info.start_time + ' 00:00:00').getTime() / 1000 : '',
            end_time: this.search_info.end_time ? new Date(this.search_info.end_time + ' 23:59:59').getTime() / 1000 : '',
          }
        )
        if (response.status === 200 && result.code === 0) {
          this.statistic_data = result.data
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取活动数据统计失败',
            content: `${response.status} ${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取活动数据统计失败',
          content: `错误：${err}`,
        })
      }
    },
    // 获取助力统计列表
    async getList () {
      let params = {
        id: this.help_id,
        mobile: this.query_data.keyword,
        page: this.pagination_data.current_page,
        per_page: this.pagination_data.per_page,
        start_time: this.search_info.start_time ? new Date(this.search_info.start_time + ' 00:00:00').getTime() / 1000 : '',
        end_time: this.search_info.end_time ? new Date(this.search_info.end_time + ' 23:59:59').getTime() / 1000 : '',
      }
      if (this.query_data.status.id) {
        params.status = this.query_data.status.id
      }
      try {
        const { response, result } = await this.helpListApi(params)
        if (response.status === 200 && result.code === 0) {
          this.list = result.data
          this.pagination_data = result.meta
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取活动数据统计失败',
            content: `${response.status} ${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取活动数据统计失败',
          content: `错误：${err}`,
        })
      }
    },
  },
  mounted () {
    this.help_id = this.$route.query.help_id - 0
    this.activity_id = this.$route.query.activity_id - 0
    let search = localStorage.getItem('help-search')
    if (search) {
      this.search_info = JSON.parse(search)
    }
    this.getStatistic()
    this.getList()
  },
}
</script>

<style scoped lang="stylus">
@import '~@/stylus/mixins'
// @import '~@/stylus/modules/creation-modal'
.no-border
  border none !important 
.head-content
  display flex
  justify-content space-between
.section-layout
  height calc(100% - 56px)
.content-layout-list
  min-height calc(100% - 346px)
  overflow-y auto
.margin
  margin 0 8px
  font-size 14px
.nav-back-btn
  position absolute
  top 18px
  left 16px
  width 32px
  height 32px
  border-radius 100%
  background #CED3DC center no-repeat url('~@/assets/back.svg')
  background-size 16px
  box-shadow 0 2px 6px 0 rgba(0, 0, 0, 0.08)
  cursor pointer
  z-index 2
.title-filter
  padding 25px 65px 10px
  background #e8e9eb
.time
  position absolute
  right 40px
  bottom 20px
  border-radius 3px
  box-sizing border-box
.active
  color #121212 !important
  background #FFFFFF !important
.m-b-20
  margin-bottom 20px
.p-t-20
  padding-bottom 20px
.revenue
  padding-top 0px
  box-sizing border-box
.top-total
  overflow unset !important
  background #e8e9eb !important
  padding 10px 30px 0 !important
.income
  background #ffffff
  height 100px
  display flex
  justify-content flex-start
  align-items center
.statistics
  width 33%
  text-align left
  padding-left 30px
  border-left 1px solid #D9D9D9
  box-sizing border-box
  display flex
  justify-content flex-start
  align-items center
  &.max-static
    width 40%
    flex-shrink 0
  .static-item
    width 50%
    text-align left
    padding-left 30px
    box-sizing border-box
  .title
    font-size 16px
    color #999999
    font-weight 500
  .price
    margin-top 10px
    font-size 30px
    color #404040
    font-weight 500
.list-height
  height 300px
.order-statistics
  background #ffffff
  margin-top 20px
  box-sizing border-box
.inspect-store
  max-height 300px
  overflow-y auto
.order-income, .order-income-content
  background #ffffff
  display flex
  height 40px
  line-height 40px
  justify-content flex-start
  align-items center
  border-bottom 1px solid #F1F1F1
  box-sizing border-box
.order-income-content
  border-bottom none
  height 40px
  line-height 40px
.order-income li, .order-income-content li
  width 33%
  font-size 14px
  color #999999
  font-weight 500
  padding-left 30px
  display inline-block
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
li.date
  width 450px !important
.order-income-content li
  color #353535
  font-weight 400
.date
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
</style>



// WEBPACK FOOTER //
// src/components/content/HelpStatistic.vue